/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BucketValidatorDto } from '../../models/bucket-validator-dto';

export interface ValidatorControllerGetAllowedBuckets$Params {
}

export function validatorControllerGetAllowedBuckets(http: HttpClient, rootUrl: string, params?: ValidatorControllerGetAllowedBuckets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BucketValidatorDto>>> {
  const rb = new RequestBuilder(rootUrl, validatorControllerGetAllowedBuckets.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BucketValidatorDto>>;
    })
  );
}

validatorControllerGetAllowedBuckets.PATH = '/validator/bucket-validator';
